// extracted by mini-css-extract-plugin
export default {"button":"BlockButton_button__GejOC","link":"BlockButton_link__TbdbQ"};